import React from 'react';
import { Header, Icon } from 'semantic-ui-react';
import { CartItemPropType } from '../../../../domains/checkout/CartSummary/CartSummary.propTypes';
import Modal from '../../../foundation/components/Modal';
import CartAdjustments from '../CartAdjustments';
import { hasAdjustments } from '../CartAdjustments/CartAdjustments.utils';
import './CartAdjustmentsModal.css';
var defaultProps = {
  header: null,
  open: false,
  onClose: null,
  onOpen: null,
  trigger: null
};
export default function CartAdjustmentsModal(_ref) {
  var items = _ref.items,
    onRemoveItem = _ref.onRemoveItem,
    onComplete = _ref.onComplete,
    header = _ref.header,
    open = _ref.open,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    trigger = _ref.trigger;
  if (!hasAdjustments(items)) {
    return null;
  }
  var finalHeader = header || /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, {
    as: "h2"
  }, "Important changes to items in your cart"), onClose && /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    onClick: onClose
  }));
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose,
    onOpen: onOpen,
    trigger: trigger,
    open: open,
    dimmer: "inverted",
    className: "cart-adjustments-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, null, finalHeader), /*#__PURE__*/React.createElement(Modal.Content, {
    scrolling: true
  }, /*#__PURE__*/React.createElement(CartAdjustments, {
    header: null,
    items: items,
    onRemoveItem: onRemoveItem,
    onComplete: onComplete
  })));
}
CartAdjustmentsModal.defaultProps = defaultProps;